package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.PlayCircleW500Rounded: ImageVector
    get() {
        if (_playCircleW500Rounded != null) {
            return _playCircleW500Rounded!!
        }
        _playCircleW500Rounded = Builder(name = "PlayCircleW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(430.54f, 629.28f)
                lineToRelative(188.31f, -120.69f)
                quadToRelative(15.91f, -10.32f, 15.91f, -28.65f)
                reflectiveQuadToRelative(-15.91f, -28.53f)
                lineTo(430.54f, 330.72f)
                quadToRelative(-16.91f, -11.2f, -34.68f, -1.54f)
                reflectiveQuadToRelative(-17.77f, 30.12f)
                verticalLineToRelative(241.4f)
                quadToRelative(0.0f, 20.46f, 17.77f, 30.12f)
                reflectiveQuadToRelative(34.68f, -1.54f)
                close()
                moveTo(480.0f, 888.13f)
                quadToRelative(-84.91f, 0.0f, -159.34f, -32.12f)
                quadToRelative(-74.44f, -32.12f, -129.5f, -87.17f)
                quadToRelative(-55.05f, -55.06f, -87.17f, -129.5f)
                quadTo(71.87f, 564.91f, 71.87f, 480.0f)
                reflectiveQuadToRelative(32.12f, -159.34f)
                quadToRelative(32.12f, -74.44f, 87.17f, -129.5f)
                quadToRelative(55.06f, -55.05f, 129.5f, -87.17f)
                quadToRelative(74.43f, -32.12f, 159.34f, -32.12f)
                reflectiveQuadToRelative(159.34f, 32.12f)
                quadToRelative(74.44f, 32.12f, 129.5f, 87.17f)
                quadToRelative(55.05f, 55.06f, 87.17f, 129.5f)
                quadToRelative(32.12f, 74.43f, 32.12f, 159.34f)
                reflectiveQuadToRelative(-32.12f, 159.34f)
                quadToRelative(-32.12f, 74.44f, -87.17f, 129.5f)
                quadToRelative(-55.06f, 55.05f, -129.5f, 87.17f)
                quadTo(564.91f, 888.13f, 480.0f, 888.13f)
                close()
                moveTo(480.0f, 797.13f)
                quadToRelative(133.04f, 0.0f, 225.09f, -92.04f)
                quadToRelative(92.04f, -92.05f, 92.04f, -225.09f)
                quadToRelative(0.0f, -133.04f, -92.04f, -225.09f)
                quadToRelative(-92.05f, -92.04f, -225.09f, -92.04f)
                quadToRelative(-133.04f, 0.0f, -225.09f, 92.04f)
                quadToRelative(-92.04f, 92.05f, -92.04f, 225.09f)
                quadToRelative(0.0f, 133.04f, 92.04f, 225.09f)
                quadToRelative(92.05f, 92.04f, 225.09f, 92.04f)
                close()
                moveTo(480.0f, 480.0f)
                close()
            }
        }
        .build()
        return _playCircleW500Rounded!!
    }

private var _playCircleW500Rounded: ImageVector? = null
